// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__QnqP9","navbar__link":"style_navbar__link__qpFPI","container":"style_container__zlFab","wrapper":"style_wrapper__itp6J","title":"style_title__RDbwX"};